const options = {
    responsive: true,
    scales: {
        y: {
            ticks: {
                callback: (value, index, ticks) =>
                    value.toLocaleString('vi-VN'),
            },
        },
    },
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: false,
        },
        datalabels: {
            formatter: function (value, context) {
                return '';
            },
        },
    },
};

export { options };
